import React from "react";

import { useAppRouteParams } from "../../../AppRoutes";
import { useVersionPresenceMembers } from "../../InOrganizationProvider/SessionProvider/hooks";
import { SessionsFacepile } from "../../SessionsFacepile";

/**
 * @description バージョン配下にいるメンバーの在席 facepile。
 * シート/ビューのように在席メンバーを自前で持たないページ向けのフォールバックとして使う。
 */
export const VersionSessionsFacepile: React.FC = () => {
  const { versionId } = useAppRouteParams();
  const accessMembersRaw = useVersionPresenceMembers(versionId);

  // NOTE: SessionsFacepile は空でも固定幅の箱を描くため、描画対象がない場合は出さない
  if (accessMembersRaw.length === 0) return null;

  return <SessionsFacepile accessMembersRaw={accessMembersRaw} />;
};
